const LangMobileOrdering = {
  "mobileOrdering._title": [
    "Please scan QR code assigned <br/> to your table to order",
    "Vui lòng quét mã QR được gán cho bàn của bạn để đặt hàng"
  ]
};
export default LangMobileOrdering;
